export const MARGEN_COMERCIAL = 1;
export const IMPORTE_GANANCIA = 2;
export const PRECIO_VENTA = 3;
